import React from "react";
import {
  Box,
  Chip,
} from "@mui/material";
import { MaterialReactTable } from "material-react-table";
import { MRT_Localization_VI } from "material-react-table/locales/vi";
import { getRoleColor } from "modules/systems/utils/permission.utils";
import DataTable from "components/common/tables/DataTable";

const UserTable = ({ users, onSelectUser, selectedUser }) => {
  const columns = [
    {
      accessorKey: "userName",
      header: "Tên đăng nhập",
      muiTableHeadCellProps: {
        sx: {
          left: 0,
          minWidth: 50,
          maxWidth: 80,

          backgroundColor: "#0b5cab",
          color: "#fff",
          fontSize: 11,
          fontWeight: 700,
          lineHeight: 1.3,
          py: 1,
          overflow: "hidden",
          textOverflow: "ellipsis",
          whiteSpace: "normal",
          wordBreak: "break-word",
          borderBottom: 0,
          borderRight: "1px solid rgba(255,255,255,.25)",
          position: "sticky",
          top: 0,
          zIndex: 3,
          "&:last-of-type": { borderRight: 0 },
          "& .MuiIconButton-root": { color: "#fff" },
          textAlign: "center",
          "& .Mui-TableHeadCell-Content": {
            justifyContent: "center",
          },
        },
      },
      muiTableBodyCellProps: {
        sx: {
          position: "sticky",
          left: 0,
          zIndex: 1,
          background: "#fff",
          minWidth: 50,
          maxWidth: 80,
          fontSize: 12,
        },
      },
    },
    {
      accessorKey: "fullName",
      header: "Họ tên",
      size: 140,
      muiTableBodyCellProps: () => {
        return {
          align: 'left',
        };
      },
    },
    {
      accessorKey: "roleName",
      header: "Vai trò",
      size: 140,
      Cell: ({ cell }) => {
        const roles = cell.getValue()
        return (
          <Box
            sx={{
              display: "flex",
              flexWrap: "wrap",
              gap: 0.5,
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            {roles ? (
              <Chip
                label={roles}
                size="small"
                sx={{
                  backgroundColor: getRoleColor(roles),
                  color: "#fff",
                  fontWeight: 600,
                }}
              />
            ) : (
              <Chip label="Không có" size="small" color="default" />
            )}
          </Box>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={users}
      enableColumnActions={false}
      enablePagination={false}
      enableSorting={true}
      renderTopToolbarCustomActions={({ table }) => (
        <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
          <div style={{ fontSize: 14, color: "rgba(0,0,0,0.6)" }}>
            Tổng: {table.getPrePaginationRowModel().rows.length}
          </div>
        </div>
      )}
    muiTableBodyRowProps={({ row }) => ({
      hover: true,
      onClick: () => onSelectUser(row.original),
      sx: {
        cursor: "pointer",
        backgroundColor:
          selectedUser?.userId === row.original.userId ? "#e3f2fd" : "#fff",
      },
    })}
    />
  );
};

export default UserTable;
